module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.showModalBoleto && _vm.ultimaSolicitacao) ? _c('modal-boleto', {
    attrs: {
      "solicitacao": _vm.ultimaSolicitacao
    },
    on: {
      "close": function () {
        _vm.showModalBoleto = false;
        _vm.ultimaSolicitacao = null;
        this$1.selecionaProximo();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showModalDuplicacao) ? _c('modal-duplicacao', {
    attrs: {
      "solicitacoesNaoResolvidas": _vm.solicitacoesNaoResolvidas
    },
    on: {
      "confirma": function (justificativa) { return _vm.confirmaDuplicacao(justificativa); },
      "close": function () {
        _vm.showModalDuplicacao = false;
        _vm.solicitacoesNaoResolvidas = []
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showModalExtrapolacao) ? _c('modal-extrapolacao', {
    attrs: {
      "vagaSelecionada": _vm.vagaSelecionada
    },
    on: {
      "confirma": function (justificativa) { return _vm.confirmaExtrapolacao(justificativa); },
      "close": function () {
        _vm.showModalExtrapolacao = false;
        _vm.vagaSelecionada = null
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('pre', [_vm._v(_vm._s(_vm.vagaSelecionada))]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "panel panel-default panel-table"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-xs-12"
  }, [_c('h3', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        _vm.teste()
      }
    }
  }, [_c('b', [_vm._v("Procedimentos da Solicitação")]), _vm._v(" "), _c('small', [_vm._v("Selecione um procedimento para verificar os atendimentos disponíveis.")])])])])]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-striped table-bordered table-list stripe table-hover table-seleciona-procedimento"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', {
    attrs: {
      "id": "corpo-table-procedimentos-agendados"
    }
  }, [_vm._l((_vm.procedimentos.individual), function(item, index) {
    return _c('tr', {
      key: index,
      class: {
        'ativa': _vm.procedimentoSelecionado.index === index,
        'resolvido': item.status == 'resolvido',
        'pendente': item.status == 'pendente'
      },
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.selecionaProcedimentoIndividual(index, item)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('i', {
      class: item.status == 'resolvido' ? 'fa fa-check' : 'fa fa-exclamation-triangle',
      attrs: {
        "title": item.status == 'resolvido' ? 'Resolvido' : 'Pendente'
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.procedimento_quantidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.procedimento_codigo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("uppercase")(item.procedimento_nome)))]), _vm._v(" "), _c('td', [_vm._v("AGENDAMENTO")])])
  }), _vm._v(" "), _vm._l((_vm.procedimentos.agrupado), function(item, index) {
    return _c('tr', {
      key: item.id,
      class: {
        'ativa': _vm.procedimentoSelecionado.index === index,
        'resolvido': item[0].status == 'resolvido',
        'pendente': item[0].status == 'pendente'
      },
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.selecionaProcedimentoAgrupado(index, item)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "text-align": "center",
        "vertical-align": "middle"
      }
    }, [_c('i', {
      class: item[0].status == 'resolvido' ? 'fa fa-check' : 'fa fa-exclamation-triangle',
      attrs: {
        "title": item[0].status == 'resolvido' ? 'Resolvido' : 'Pendente'
      }
    })]), _vm._v(" "), _c('td', _vm._l((item), function(proc) {
      return _c('span', [_vm._v("\n                            " + _vm._s(proc.procedimento_quantidade) + "\n                            "), _c('br')])
    })), _vm._v(" "), _c('td', _vm._l((item), function(proc) {
      return _c('span', [_vm._v("\n                            " + _vm._s(proc.procedimento_codigo) + "\n                            "), _c('br')])
    })), _vm._v(" "), _c('td', _vm._l((item), function(proc) {
      return _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("uppercase")(proc.procedimento_nome)) + "\n                            "), _c('br')])
    })), _vm._v(" "), _c('td', {
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_c('span', [_vm._v("[" + _vm._s(_vm._f("tipoAgrupamento")(item[0].procedimento_tipo_agrupamento)) + "] SELEÇÃO DE UNIDADES PARA AGRUPADOS")])])])
  })], 2)])])])]), _vm._v(" "), (_vm.procedimentoSelecionado.tipo == 'agrupado') ? _c('resolucao-agrupado', {
    attrs: {
      "solicitacao-id": _vm.solicitacaoId,
      "vagasApi": _vm.vagasApi,
      "dataNascimentoPaciente": this.$store.state.solicitacao.dadosResolucao.paciente.data_nascimento
    },
    on: {
      "confirma": function (vagasSelecionadas) {
        _vm.confirmaAgrupado(vagasSelecionadas)
      },
      "enviaRegulacao": function (vagasSelecionadas, motivo) {
        _vm.enviaRegulacaoAgrupado(vagasSelecionadas, motivo)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.procedimentoSelecionado.tipo == 'individual') ? _c('resolucao-individual', {
    attrs: {
      "solicitacao-id": _vm.solicitacaoId,
      "vagasApi": _vm.vagasApi,
      "tipoVaga": _vm.procedimentoSelecionado.tipo_consulta,
      "dataNascimentoPaciente": this.$store.state.solicitacao.dadosResolucao.paciente.data_nascimento
    },
    on: {
      "confirma": function (vagaSelecionada) {
        _vm.confirmaIndividual(vagaSelecionada)
      },
      "enviaRegulacao": function (vagaSelecionada, motivo) {
        _vm.enviaRegulacaoIndividual(vagaSelecionada, motivo)
      }
    }
  }) : _vm._e()], 1)])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Resolução da Solicitação")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Qtd.")]), _vm._v(" "), _c('th', [_vm._v("Código")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Tipo de Pendência")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7d00458d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atendimentos/solicitacao/resolucao.vue
// module id = 877
// module chunks = 0